<template>
  <div class="launch-reim">
    <div class="launch-reim-header">
      <l-header></l-header>
      <div class="header-title">发起报销</div>
    </div>
    <div class="background">
      <div></div>
    </div>
    <div class="content">
      <InputField :formList="formList" :formData.sync="formData" @onFocus="onFocus" :defaultIndex="defaultIndex"></InputField>
      <OnlyChangeDept :hide='true' :visible="deptVisible" :deptInfo="{deptId: formData.deptId, deptName: formData.deptName}" @onCloseDeptPopup="onCloseDeptPopup"  @onSelectDept="onSelectDept"></OnlyChangeDept>
      <div class="tab-list">
        <van-sticky :offset-top="90" @change="handleChange" :class="[stickyShow ? 'self-van-sticky' : '']">
          <div :class="['sticky-div', stickyShow ? 'big-sticky-div' : '']">
              <van-tabs v-model="active" title-active-color="#3378FF" title-inactive-color="#7A8699">
                <van-tab class="select" :title-class="active === 0 ? 'bot-line' : ''">
                  <template #title>
                    <div class="tab-title">
                      <div>发票</div>
                      <div :class="['tab-list-num', active === 0 ? 'select-tab-num' : '']">{{list.length}}</div>
                    </div>
                  </template>
                </van-tab>
                <van-tab class="select" :title-class="active === 1 ? 'bot-line' : ''">
                  <template #title>
                    <div class="tab-title">
                      <div>附件</div>
                      <div :class="['tab-list-num', active === 1 ? 'select-tab-num' : '']">{{files.length}}</div>
                    </div>
                  </template>
                </van-tab>
              </van-tabs>
              <div v-if="active === 0" class="add" @click="handleAdd"><span class="huisuiyunfont">{{'\ue672'}}</span>添加发票</div>
            </div>
            <div v-if="active === 0" :class="['sticky-tips',stickyShow ? 'big-sticky-tips' : '' ]">
              <div>共关联 {{list.length}} 张发票，合计金额 {{Number(sum).toFixed(2)}} 元</div>
              <div></div>
            </div>
            <div v-else :class="['sticky-tips',stickyShow ? 'big-sticky-tips' : '' ]">
              <div>共关联 {{files.length}} 个附件</div>
              <div></div>
            </div>
          </van-sticky>
          <div v-if="active === 0" class="tab-content">
            <transition-group name="list">
              <div class="card-father" v-for="(item) in list" :key="item.id">
                <div :class="`card ${errorList.find(i => (i.id === item.id && i.accordInvoiceTime === 0)) ? 'error-card' : ''}`">
                  <div class="card-top">
                    <div class="no" v-if="item.invoiceSource === 1">异</div>
                    <div class="no" v-else-if="item.checkFlag === 0">未</div>
                    <div class="ok" v-else-if="item.checkFlag === 1 || item.checkFlag === 4">验</div>
                    <div v-else class="ok">验</div>
                    <div :class="[getColor(item.invoiceType)]">{{getType(item.invoiceType)}}</div>
                    <div class="card-top-name">{{getTitle(item)}}</div>
                    <div class="del huisuiyunfont" @click="handleDel(item)">{{'\ue61c'}}</div>
                  </div>
                  <div class="card-bottom">
                    <div>{{item.drewDate}}</div>
                    <div></div>
                    <div class="first-goods-name" v-if="item.invoiceType === '207'">{{ item.mileage+'km'}}</div>
                    <div class="first-goods-name" v-else-if="(item.invoiceType === '202')">{{item.agentCode}}</div>
                    <div class="first-goods-name" v-else-if="(item.invoiceType === '201')">{{item.trainNumber}}</div>
                    <div class="first-goods-name" v-else>{{item.firstGoodsName ? item.firstGoodsName : '--'}}</div>
                    <div>{{Number(item.amountWithTax).toFixed(2)}}</div>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
          <div v-else class="tab-content">
            <div style="padding: 0 8px; box-sizing: border-box;">
              <l-fileup
                :fileList="files"
                @oninputchange="($event) => onInputChange({e: $event, field:'files'})"
                @finishUpload="finishUploadFile"
                @beforeDelete="deletePic">
              </l-fileup>
            </div>
          </div>
      </div>
    </div>
    <div class="footer">
      <div>
        <div>报销金额 (可编辑) </div>
        <div>
          <span class="iconfont money-icon">{{'\ue60a'}}</span>
          <input v-model="editValue" placeholder="请输入金额"/>
        </div>
      </div>
      <div @click="handleSubmit">提交报销</div>
    </div>
    <PopMask :pop-show.sync="show" :close="false">
      <div class="pop">
        <div class="icon huisuiyunfont">{{'\ue66d'}}</div>
        <div></div>
        <div class="title">提交成功</div>
        <div class="btn">
          <div @click="handleGo('/ticket/center/index')">返回票夹</div>
          <div @click="handleGo('/reimbursement/reimList')">查看报销单</div>
        </div>
      </div>
    </PopMask>
  </div>
</template>
<script>
import Header from '@/components/Header/index.vue'
import PopMask from '@/components/PopMask/index.vue'
import { personalInvoicesRequest } from '@/services'
import OnlyChangeDept from '@/components/OnlyChangeDept'
import { getInvoiceType, getInvoiceColor, getDingCode } from '@utils/basicUtil'
import InputField from './inputList.vue'
import FileUp from '@/components/FileUp'
import { ExpenseTypeMap } from '@assets/config'
import { mapActions, mapState, mapMutations } from 'vuex'
import { Sticky, PullRefresh, List, Notify, Empty, Tab, Tabs, Uploader, Toast, Field, Popup, picker } from 'vant'
export default {
  data () {
    return {
      columns: ['办公', '餐饮', '通讯', '飞机', '火车', '巴士', '打车', '住宿', '餐补', '里程', '娱乐', '福利', '快递', '其他'],
      showPicker: false,
      defaultIndex: 0,
      formList: [
        {
          label: '报销人',
          placeholder: '请填写报销人 ( 必填 ) ',
          field: 'reimApplicant'
        },
        {
          label: '所在部门',
          placeholder: '请选择所在部门',
          field: 'deptName',
          readonly: true
        },
        {
          label: '报销事由',
          placeholder: '请填写报销事由 ( 必填 )',
          field: 'reimReason'
        },
        {
          label: '备注',
          placeholder: '请填写备注 ( 非必填 ) ',
          field: 'remark'
        },
        {
          label: '费用类型',
          placeholder: '请选择类型 ( 必填 ) ',
          field: 'expenseType',
          readonly: true
        }
      ],
      active: 0,
      sum: 0,
      show: false,
      submitBtn: false,
      invoiceIds: [],
      stickyShow: false,
      editValue: 0,
      formData: {
        expenseType: '',
        reimApplicant: '',
        reimReason: '',
        remark: '',
        reimNo: ''
      },
      files: [],
      list: [],
      accessCodes: [],
      deptVisible: false
    }
  },
  components: {
    'l-header': Header,
    'l-fileup': FileUp,
    [Toast.name]: Toast,
    PopMask,
    InputField,
    OnlyChangeDept,
    [Uploader.name]: Uploader,
    [picker.name]: picker,
    [Sticky.name]: Sticky,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Notify.name]: Notify,
    [Empty.name]: Empty,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  methods: {
    ...mapActions('reimModels', ['saveOrUpdate', 'getReimInfo', 'getReimList']),
    ...mapMutations('reimModels', ['setErrorList']),
    handleChange () {
      this.stickyShow = !this.stickyShow
    },
    handleGo (url) {
      this.$router.push(url)
      sessionStorage.clear()
    },
    onInputChange ({ e, field }) {
      console.log(e, field)
    },
    finishUploadFile (result, f) {
      if (result.code === '200') {
        let res = [
          ...this.files
        ]
        const target = {
          url: result.fileUrl,
          originFileName: f.file.name,
          fileSize: f.file.size,
          fileDirectory: result.fileUrl
        }
        res.push(target)
        this.files = res
      } else {
        Notify({ type: 'danger', message: result.message })
      }
    },
    deletePic (file) {
      let res = this.files.filter(item => item.url !== file.url)
      this.files = res
    },
    async handleSubmit () {
      if (this.submitBtn) {
        return
      }
      if (!this.formData.expenseType) {
        return Notify({ type: 'danger', message: '请输入费用类型!' })
      }
      if (this.editValue === '') {
        return Notify({ type: 'danger', message: '请输入报销金额!' })
      }
      if (!(this.formData.reimApplicant && this.formData.reimReason)) {
        return Notify({ type: 'danger', message: '请填写必填信息!' })
      }
      let count = this.files.length + this.invoiceIds.length + 5
      let accessCodes = []
      for (let i = 0; i < count; i++) {
        let code = await getDingCode()
        if (code) {
          accessCodes.push(code)
        }
      }

      Toast.loading({
        message: '正在提交...',
        forbidClick: true,
        duration: 1000,
        onClose: async () => {
          this.submitBtn = true
          let query = {
            attachmentInfos: this.files,
            invoiceIds: this.invoiceIds,
            reimAmount: this.editValue,
            accessCodes,
            drewDates: this.list && Array.isArray(this.list) ? this.list.map(i => ({ drewDate: i.drewDate, id: i.id })) : [],
            ...this.formData
          }
          const res = await this.saveOrUpdate(query)
          if (res) {
            this.show = true
            sessionStorage.removeItem('formData')
            sessionStorage.removeItem('selCardList')
            sessionStorage.removeItem('files')
          } else {
            this.show = false
            this.submitBtn = false
          }
        }
      })
    },
    handleDel ({ id }) {
      this.sum = 0
      this.invoiceIds = []
      let cardList = JSON.parse(sessionStorage.cardList)
      let newList = this.list.filter(item => {
        return item.id !== id
      })
      let newCardList = cardList.map(item => {
        if (item.id === id) {
          item.flag = false
        }
        return item
      })
      this.list = newList
      if (this.list.length > 0) {
        this.list.forEach(item => {
          let obj = {}
          obj.invoiceId = item.id
          obj.invoiceCodeNo = (item.invoiceCode || '') + (item.invoiceNo || '')
          if (item.invoiceType === '201' || item.invoiceType === '202' || item.invoiceType === '207' || item.invoiceType === '200') {
            obj.type = 2
          } else {
            if (item.invoiceSource === 1) {
              obj.type = 1
            } else {
              obj.type = 0
            }
          }
          this.sum += Number(item.amountWithTax)
          this.invoiceIds.push({ ...obj })
        })
      }
      this.sum = Number(this.sum).toFixed(2)
      this.editValue = Number(this.sum).toFixed(2)
      sessionStorage.selCardList = JSON.stringify(newList)
      sessionStorage.cardList = JSON.stringify(newCardList)
    },
    handleGetList (id) {
      let flag = false
      if (this.reimInfo.invoiceInfos.length > 0) {
        this.reimInfo.invoiceInfos.map(i => {
          if (i.invoiceNo === id) {
            flag = true
          }
        })
      }
      return flag
    },
    handleAdd () {
      sessionStorage.formData = JSON.stringify(this.formData)
      sessionStorage.files = JSON.stringify(this.files)
      this.$router.push('/ticket/center/index')
    },
    handleInit () {
      if (sessionStorage.files) {
        this.files = JSON.parse(sessionStorage.files)
      }
      if (sessionStorage.formData) {
        this.formData = JSON.parse(sessionStorage.formData)
      }
      if (sessionStorage.selCardList) {
        this.list = JSON.parse(sessionStorage.selCardList)
      }
      console.log('到这里了', this.formData)
      if (this.list.length > 0) {
        this.list.forEach(item => {
          let obj = {}
          obj.invoiceId = item.id
          obj.invoiceCodeNo = (item.invoiceCode || '') + (item.invoiceNo || '')
          console.log(item.invoiceType)
          if (item.invoiceType === '201' || item.invoiceType === '202' || item.invoiceType === '207' || item.invoiceType === '200') {
            obj.type = 2
          } else {
            if (item.exceptionInfo !== '0' && item.exceptionInfo != null) {
              obj.type = 1
            } else {
              obj.type = 0
            }
          }
          this.sum += Number(item.amountWithTax)
          this.invoiceIds.push({ ...obj })
        })
      }
      this.sum = Number(this.sum).toFixed(2)
      this.editValue = Number(this.sum).toFixed(2)
    },
    onFocus (item) {
      if (item.field === 'deptName') {
        this.deptVisible = true
      }
      if (item.field === 'expenseType' && item.value) {
        this.formData.expenseType = item.value
      }
    },
    onSelectDept (item) {
      const { deptId, deptName } = item
      this.formData = {
        ...this.formData,
        deptId,
        deptName
      }
    },
    onCloseDeptPopup () {
      this.deptVisible = false
    }
  },
  async created () {
    this.setErrorList([])
    if (sessionStorage.selCardList) {
      this.handleInit()
    }
    if (this.$route.query.id) {
      let newList = []
      let files = []
      await this.getReimInfo(this.$route.query.id)
      let res = await personalInvoicesRequest.personalInvoices.cardList({
        current: 1,
        size: 999999,
        startDrewDate: '',
        endDrewDate: '',
        status: '',
        invoiceType: '',
        reimStatus: ''
      })
      let newCard = res.result.records
      newCard.map(i => {
        i.flag = this.handleGetList(i.invoiceNo)
        newList.push(i)
      })
      sessionStorage.cardList = JSON.stringify(newList)
      this.reimInfo.attachmentInfos.map(item => {
        let obj = { ...item }
        obj.url = item.fileDirectory
        files.push(obj)
      })
      sessionStorage.files = JSON.stringify(files)
      this.formData = {
        reimApplicant: this.reimInfo.reimApplicant,
        reimReason: this.reimInfo.reimReason,
        remark: this.reimInfo.remark,
        reimNo: this.reimInfo.reimNo,
        expenseType: this.reimInfo.expenseType
      }
      sessionStorage.selCardList = JSON.stringify(this.reimInfo.invoiceInfos)
      sessionStorage.oldSelCardList = JSON.stringify(this.reimInfo.invoiceInfos)
      this.handleInit()
    } else { // 新增逻辑
      this.formData = {
        ...this.formData,
        reimApplicant: this.formData.reimApplicant ? this.formData.reimApplicant : this.userInfo ? this.userInfo.trueName : ''
      }
    }
  },
  computed: {
    ...mapState('reimModels', ['reimInfo', 'errorList']),
    getExpenseTypeMap () {
      return ExpenseTypeMap
    },
    getTitle () {
      return (item) => {
        if (item.sellerName) {
          return item.sellerName
        } else if (item.invoiceType === '200') {
          return '国家税务局通用定额发票'
        } else if (item.invoiceType === '202') {
          return item.issueBy
        } else if (item.invoiceType === '51' || item.invoiceType === '61') {
          return item.purchaserName
        } else if (item.place) {
          return item.place
        } else {
          return item.stationGetOn + ' - ' + item.stationGetOff
        }
      }
    },
    getType () {
      return (item) => {
        return getInvoiceType(item)
      }
    },
    getColor () {
      return (item) => {
        return getInvoiceColor(item)
      }
    },
    userInfo () {
      return this.$store.state.user.userInfo
    }
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
